import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { TerminalDepositModesEnum } from '@app/dev/constants/enums/terminalDepositModes';
import KeyboardFormField from '@common/components/keyboardFormField';
import { openDeferModal } from '@tickets/helpers/openDeferPopup';
import { useTranslation } from '@common/hooks/translation';
import ToastWrapper from '@common/helpers/toastWrapper';
import Helpers from '@common/helpers/helperFunctions';
import { POPUPS } from '@common/constants/popups';

import './style.scss';
import { broadcast, broadcastChannels } from '@common/helpers/broadcast';

export const checkCnp = (cnp) => new Promise((resolve) => {
  broadcast.addEventListener(broadcastChannels.GetCnpCheckResult, (e) => resolve(e.detail), { once: true });
  window.jsobject.checkCnp(cnp);
});

export const fields = [
  {
    name: 'CNP',
    fieldName: 'CNP',
    isFieldValid: (value) => Helpers.validateCNP(value),
    errorMessage: 'CNP is not correct or You need to be over 18',
  },
];

const CnpVerificationPopup = ({ defer, player }) => {
  const t = useTranslation();
  const { isAdminLoggedIn, depositMode } = useSelector((state) => state.terminal);
  const [cnp, setCnp] = useState('');

  const handleSubmit = async () => {
    if (
      player
      && Object.keys(player || {}).length !== 0
      && depositMode !== TerminalDepositModesEnum.Cash
      && player.PersonalId?.toLowerCase() !== cnp?.toLowerCase()
    ) {
      ToastWrapper('error', "You can't pay other players tickets");
    } else {
      const cnpResult = await checkCnp(cnp);

      if (cnpResult) {
        const data = await openDeferModal(POPUPS.WIN_IDENTIFICATION, { autofillData: cnpResult })
        defer.resolve(data);
      } else {
        defer.resolve(null);
      }
    }
  };

  return (
    <div className="popup-content popup-small win-identification">
      <h3 className="popup-title">{t('Enter Cnp')}</h3>
      <div className="input-wrapper cnp-input">
        {fields.map((item) => (
          <KeyboardFormField
            key={item.name}
            name={item.fieldName}
            value={cnp}
            onChange={setCnp}
          />
        ))}
      </div>
      <div className="popup-actions">
        <button
          type="button"
          onClick={() => defer.resolve(null)}
          className={`popup-cancel-button ${!isAdminLoggedIn ? 'register-cancel' : ''}`}
        >
          {t('Cancel')}
        </button>
        {!isAdminLoggedIn && (
          <button
            disabled={!cnp}
            type="button"
            onClick={handleSubmit}
            className="popup-confirm-button"
          >
            {t('Continue')}
          </button>
        )}
        {isAdminLoggedIn && (
          <button
            type="button"
            onClick={() => openDeferModal(POPUPS.WIN_IDENTIFICATION)}
            className="popup-confirm-button"
          >
            {t('Enter manually')}
          </button>
        )}
      </div>
    </div>
  );
};

CnpVerificationPopup.propTypes = {
  player: PropTypes.object,
  defer: PropTypes.object.isRequired,
};

export default CnpVerificationPopup;
